import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";
import sharedStyles from "../../styles/shared.module.scss";
import styles from "./categoriesList.module.scss";
import css from "@/components/new-resolver/.module.scss";
import AppLink from "@/components/new-resolver/app.ink";
import { usePath } from "@/contexts/path/path";
import { useQuery } from "@apollo/client";
import { GET_RED_CITIES } from "@/graphql/queries/regions";

const cx = classnames.bind(styles);

const CitiesList = React.memo(({ mode }) => {
  const [citiesPositions, setCitiesPositions] = useState({});

  const { updateContext, city } = usePath();

  const { data: { RealEstateProjects: { cities } = {} } = {} } =
    useQuery(GET_RED_CITIES);
  // useHorizontalScroll(citiesRef);

  const getCityPosition = (index) => {
    index = index - 1 <= 0 ? 0 : index - 1;
    const citiesPositionsValues = Object.values(citiesPositions);
    if (index === 0) {
      return citiesPositionsValues
        .slice(0, citiesPositionsValues.length - 1)
        .reduce((a, b) => a + b, 0);
    }
    if (citiesPositionsValues.length > 0) {
      return citiesPositionsValues.slice(0, index).reduce((a, b) => a - b, 0);
    }
  };

  // useEffect(() => {
  //   smoothscroll.polyfill();
  //   Object.entries(cityRef.current).forEach(([catUri, el]) => {
  //     if (!el) return;
  //     setCitiesPositions((prev) => {
  //       return {
  //         ...prev,
  //         ...{ [catUri]: el.getBoundingClientRect().width },
  //       };
  //     });
  //   });
  // }, []);

  // useEffect(() => {
  //   const activeCityIndex = Object.keys(citiesPositions).findIndex(
  //     (uri) => uri === activeCity,
  //   );
  //   citiesRef?.current?.scrollTo({
  //     left: getCityPosition(activeCityIndex),
  //     behavior: "smooth",
  //   });
  // }, [activeCity, citiesPositions, citiesRef]);

  const containerClasses = cx("categoriesContainer", {
    absolute: mode === "map",
  });

  const citiesListClasses = classnames({
    [styles.categoriesList]: true,
    [sharedStyles.touchActionPanX]: mode === "map",
  });

  return (
    <div className={`${css.category} ${css.redCities}`}>
      <button
        type="button"
        className={css.search}
        onClick={(event) => {
          event.stopPropagation();
          // appHistory.pushState({}, "", "#filters");
          event.target.dispatchEvent(
            new Event("opensearchbar", { bubbles: true }),
          );
        }}
      >
        بحث
      </button>
      <div className={`${css.list} ${css.redCitiesList}`}>
        <AppLink
          className={!city && css.active}
          path="/المشاريع-العقارية"
          navigate
          onClick={() => {
            updateContext({
              city: null,
              filters: {},
            });
          }}
        >
          الكل
        </AppLink>
        {cities?.map((ci) => (
          <AppLink
            className={city?.city_id === ci.city_id ? css.active : undefined}
            key={ci.city_id}
            path={ci.path}
            onClick={() => {
              updateContext({
                city: ci,
              });
            }}
          >
            {ci.name}
          </AppLink>
        ))}
      </div>
    </div>
  );
});

CitiesList.propTypes = {
  activeCity: PropTypes.string,
  mode: PropTypes.oneOf(["map", "listing"]),
};

CitiesList.defaultProps = {
  activeCity: null,
  mode: "listing",
};

export default CitiesList;
